import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * Marks a feature that requires a Shopify Plus/Enterprise plan. Rendered only for
 * non-Plus shops (paired with the feature's disabled state) as an "upgrade to
 * unlock" hint. Used on /authorization (Geowidget Map) and the /widgets hub (OOH).
 */
export function PlusBadge({ className }: { className?: string }) {
  const { t } = useTranslation('common');

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={cn('gap-1 border-[#a4c632] bg-[#e1ff7c] font-medium text-black', className)}
          >
            <Lock className="size-3" aria-hidden />
            {t('plusBadge.label')}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{t('plusBadge.tooltip')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
